import React from 'react';
import PropTypes from 'prop-types';

import './Logo.scss';

import ResponsivePicture from '../ResponsivePicture/ResponsivePicture';

export default class Logo extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        cloudinaryID: PropTypes.string.isRequired,
        alt: PropTypes.string,
    };

    render() {
        return (
            <div className="component-Elements-Logo">
                <ResponsivePicture
                    className="company-logo"
                    cloudinaryID={this.props.cloudinaryID}
                    alt={this.props.alt}
                />
            </div>
        );
    }
}
